import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import {Button, Col, Input, ListGroup, Row} from "reactstrap";
import {getCurrentMicroTime} from "../../../../reducers/timeMeasuring/actions";
import classnames from "classnames";
import InputDatetime from "./InputDatetime";
import QuestionContainer from "../Components/questionContainer";
import ResizableTextarea from "../Components/resizableTextarea";


class MultiOpen extends Component {

  constructor(props) {
    super(props);

    this['input-0'] = React.createRef();
    this['input-1'] = React.createRef();
    this['input-2'] = React.createRef();

    const values = [];
    let inputsVisible = false;
    for(let i = 0;i<props.question.answersCount;i++) {
      let detail = props.details.find((det) => det.key === i);
      if (detail) {
        values.push({
          key: detail.key,
          content: detail.content
        });

        if (i >= props.question.answersStart) {
          inputsVisible = true;
        }
      } else {
        let content = props.details.length > i && !props.details[i].key ? props.details[i].content : "";
        values.push({
          key: i,
          content: content
        });

        if (i > props.question.answersStart && content) {
          inputsVisible = true;
        }
      }
    }

    this.state = {
      tmp: 0,
      inputsVisible: inputsVisible ? props.question.answersCount : props.question.answersStart || props.question.answersCount,
      inputsFromButton: 0,
      values: values
    };

    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.updateInputsVisible = this.updateInputsVisible.bind(this);
    this.getInput = this.getInput.bind(this);
  }

  updateInputsVisible(){
    let {details} = this.props;
    let {answersStart, answersAddButtonCount} = this.props.question;
    const {inputsFromButton} = this.state;
    let inputsVisible = 0;

    if(answersAddButtonCount > 0){
      inputsVisible = answersStart + inputsFromButton;
    }else{
      inputsVisible = details.length + 1;

      if(answersStart && inputsVisible < answersStart){
        inputsVisible = answersStart;
      }
    }

    this.setState({inputsVisible})
  }

  onFocus(e){
    let {details} = this.props;
    const position = parseInt(e.target.getAttributeNode('position').nodeValue);

    if(details.length < position){
      this['input-' + details.length].current.focus();

      return;
    }

    const {answersAddButtonCount} = this.props.question;
    if(answersAddButtonCount){
      return;
    }

    const {inputsVisible} = this.state;
    const number = parseInt(e.target.attributes.position.nodeValue) + 1;

    if(number === inputsVisible){
      this.setState({inputsVisible: inputsVisible+1})
    }
  }

  onBlur(e){
    let {details} = this.props;
    const content = e.target.value;
    const key = parseInt(e.target.attributes.position.nodeValue);

    if(_.isEmpty(content)){
      delete details[key];
      this.props.onDetailsUpdated(details.filter(detail => detail)).then(() => {
        this.updateInputsVisible();
      });
    }else{
      this.updateInputsVisible();
    }
  }

  onChange(content, key){
    let {details, question} = this.props;
    const {values} = this.state;

    if(content !== '' && !!question.openRegex){
      const regex = new RegExp(question.openRegex, 'g');
      if(!regex.test(content)){
        return;
      }
    }

    const position = key + 1;
    const microTime = getCurrentMicroTime(this.props.startTime);

    let newValues = values;
    newValues[key].content = content;

    const keyIndex = details.findIndex((detail) => detail.key === key)
    if(keyIndex >= 0){
        details[keyIndex].microTime = microTime;
        details[keyIndex].content = content;
    }else{
      details.push({
        content,
        position: details.length + 1,
        microTime,
        key: key
      });
    }

    this.setState({
      values: newValues
    })
    this.props.onDetailsUpdated(details);

    this.updateInputsVisible();
  }

  getInput(i){
    const {details, validate, question} = this.props;
    const {values} = this.state;
    const value = values[i].content

    if(question.presentationType === 'datetime'){
      return <InputDatetime
          validate={validate}
        question={this.props.question}
        onChange={value => {
          this.onChange(value, i)
        }}
        value={value}
      />
    }

    const answersError = (details.length + (question.answersMin ? question.answersMin : 1)) > i;

    return <ResizableTextarea
      isError={(!_.isNull(validate) && validate.errors.length > 0) && !value && answersError}
      onChange={(e) => {
        this.onChange(e.target.value, i)
      }}
      resize={question.presentationType === 'textarea'}
      value={value}
      answer={{
        id: i,
        position: i
      }}
    />
  }

  validate(){
    const {details} = this.props;
    const {required, answersMin, validationTexts, answersCount} = this.props.question;

    let validate = {
      valid: true,
      errors: []
    };

    if(required && _.isEmpty(details)){
      validate.errors.push(validationTexts.required);
    }

    let answersWithContent = 0;
    details.forEach((entry) => {
      if (entry.content !== '') {
        answersWithContent += 1;
      }
    })

    if(answersMin > 0 && answersWithContent < answersMin){
      validate.errors.push(validationTexts.answersMin);
    }


    validate.valid = _.isEmpty(validate.errors);
    return validate;
  }

  render(){
    const {details, question} = this.props;
    const {presentationType, answersCount, answersAddButtonCount, answersColumns} = this.props.question;
    const {inputsVisible} = this.state;
    let items = [];
    const styles = {
      flexFlow: 'row wrap'
    };

      for(let i = 0; i < inputsVisible; i++){
        items.push(this.getInput(i))

        if(i+1 >= answersCount) {
          break;
        }
      }

      return <React.Fragment>
        <div className={"mb-4"}>
        <QuestionContainer classes={classnames({
          "big-gap mr-2": true,
          "no-auto-rows": answersColumns < 2
        })} answersColumns={answersColumns} component={
          <React.Fragment>
            {items.map(answer => {
              return <React.Fragment>
                <div className={classnames({
                  "grid-padding-columns": answersColumns > 1
                })}>
                  {answer}
                </div>
              </React.Fragment>
            })}
          </React.Fragment>
        } />
        {answersAddButtonCount > 0 && inputsVisible < answersCount && <div className={"round-button-wrapper"}><button
            className={"w-100 text-left rounded-button p-0"}
            color={"rounded"}
            onClick={() => {
              this.setState(
                  {
                    inputsFromButton: this.state.inputsFromButton + answersAddButtonCount
                  },
                  this.updateInputsVisible)
            }}
        ><i className={"fas fa-circle-plus ml-3 mr-3"}></i>DODAJ KOLEJNĄ ODPOWIEDŹ</button></div>}
        </div>
      </React.Fragment>
  }
}

MultiOpen.propTypes = {
  question: PropTypes.shape({
    answersCount: PropTypes.number.isRequired,
    answersStart: PropTypes.number.isRequired,
    answersMin: PropTypes.number.isRequired,
    answersAddButtonCount: PropTypes.number.isRequired,
    answersColumns: PropTypes.oneOf([1, 2, 3, 4, 6]).isRequired,
    required: PropTypes.bool.isRequired,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.string,
    position: PropTypes.number,
    microTime: PropTypes.number.isRequired,
  }).isRequired),
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  validationTexts: PropTypes.shape({
    required: PropTypes.string.isRequired,
  }).isRequired,
  intl: PropTypes.object.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true, forwardRef: true})(MultiOpen);
